export default "__VITE_ASSET__BfluzRHE__"